module.exports = __webpack_public_path__ + "img/choithrams-original-1920.48361319.webp";